import { crabDevice, readMapMesg, saveMapMesg } from '@hfzq/crab-utils';
import { LocalStorageCache } from '../local-cache-storage';

const SAVE_KEY = '_CROSS_MESG_SAVE_BUCKET';
const mapMesgStorage = new LocalStorageCache(SAVE_KEY);
const useLocalStorage = process.env.NODE_ENV === 'production' && !crabDevice.isTZT;

export const saveMapMesgCross: typeof saveMapMesg = async (params) => {
  if (useLocalStorage) {
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value !== undefined || value !== null) {
        mapMesgStorage.setSync(key.toUpperCase(), value);
      }
    });
    return {
      ERRORNO: '0',
      ERRORMESSAGE: '',
      ACTION: '',
    };
  }
  return saveMapMesg(params);
};

export const readMapMesgCross: typeof readMapMesg = async (key) => {
  if (useLocalStorage) {
    const keys: readonly string[] = typeof key === 'string' ? [key] : key;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj: any = {};
    keys.forEach((v) => {
      const saveKey = v.toUpperCase();
      obj[saveKey] = mapMesgStorage.getSync(saveKey);
    });
    return obj;
  }
  return readMapMesg(key);
};
